import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import Offerings from './components/Offerings/Offerings';
import Classes from './components/Classes/Classes';
import Trainers from './components/Trainers/Trainers';
import Schedule from './components/Schedule/Schedule';
import Testimonials from './components/Testimonials/Testimonials';
import Gallery from './components/Gallery/Gallery';
import Blog from './components/Blog/Blog';
import BookAppointment from './components/BookAppointment/BookAppointment';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ClassDetail from './components/Classes/ClassDetail';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              <About />
              <WhyChooseUs />
              <Offerings />
              <Classes />
              <Trainers />
              <Schedule />
              <Testimonials />
              <Gallery />
            </main>
          } />
          
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/appointment" element={<BookAppointment />} />
          <Route path="/classes/:id" element={<ClassDetail />} />
          
          {/* Catch-all for other paths for now */}
          <Route path="*" element={<main style={{ paddingTop: '100px', minHeight: '80vh', textAlign: 'center' }}><h2>Page Coming Soon</h2></main>} />
        </Routes>

        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
